import React from 'react';
import SVGIcon from './SVGIcon';

const SIZE_ATTRIBUTES = { width: 38, height: 38 };

export const iconSchedule = props => (
  <SVGIcon {...SIZE_ATTRIBUTES} {...props}>
    <path
      d="M32.8262 3.42725H5.17422C2.73435 3.42725 0.756348 5.40524 0.756348 7.84512V33.5822C0.756348 36.0221 2.73435 38.0001 5.17422 38.0001H32.8262C35.266 38.0001 37.244 36.0221 37.244 33.5822V7.84512C37.244 5.40512 35.266 3.42725 32.8262 3.42725Z"
      fill="#DBE9EE"
    />
    <path
      d="M37.244 11.7278V6.3749C37.244 3.93503 35.266 1.95703 32.8262 1.95703H5.17422C2.73435 1.95703 0.756348 3.93503 0.756348 6.3749V11.7278H37.244Z"
      fill="#9C1F0E"
    />
    <path
      d="M37.244 12.7266V7.84512C37.244 5.40524 35.266 3.42725 32.8262 3.42725H5.17422C2.73435 3.42725 0.756348 5.40524 0.756348 7.84512V12.7266H37.244Z"
      fill="#E10500"
    />
    <path
      d="M7.9926 5.7998C7.14102 5.7998 6.45068 6.49014 6.45068 7.34172C6.45068 8.1933 7.14102 8.88351 7.9926 8.88351C8.84418 8.88351 9.53439 8.19318 9.53439 7.34172C9.53452 6.49014 8.84418 5.7998 7.9926 5.7998Z"
      fill="#D15241"
    />
    <path
      d="M7.99286 0C7.53734 0 7.16797 0.369374 7.16797 0.824896V7.2519C7.16797 7.70755 7.53734 8.07679 7.99286 8.07679C8.44839 8.07679 8.81776 7.70755 8.81776 7.2519V0.824896C8.81776 0.369374 8.44851 0 7.99286 0V0Z"
      fill="#212021"
    />
    <path
      d="M15.331 5.7998C14.4794 5.7998 13.7891 6.49014 13.7891 7.34172C13.7891 8.1933 14.4794 8.88351 15.331 8.88351C16.1826 8.88351 16.8728 8.19318 16.8728 7.34172C16.8729 6.49014 16.1826 5.7998 15.331 5.7998Z"
      fill="#D15241"
    />
    <path
      d="M15.3312 0C14.8757 0 14.5063 0.369374 14.5063 0.824896V7.2519C14.5063 7.70755 14.8757 8.07679 15.3312 8.07679C15.7868 8.07679 16.1561 7.70755 16.1561 7.2519V0.824896C16.1561 0.369374 15.7868 0 15.3312 0V0Z"
      fill="#212021"
    />
    <path
      d="M22.6694 5.7998C21.8178 5.7998 21.1274 6.49014 21.1274 7.34172C21.1274 8.1933 21.8178 8.88351 22.6694 8.88351C23.5209 8.88351 24.2111 8.19318 24.2111 7.34172C24.2111 6.49014 23.5209 5.7998 22.6694 5.7998Z"
      fill="#D15241"
    />
    <path
      d="M22.6691 0C22.2136 0 21.8442 0.369374 21.8442 0.824896V7.2519C21.8442 7.70755 22.2136 8.07679 22.6691 8.07679C23.1247 8.07679 23.494 7.70755 23.494 7.2519V0.824896C23.494 0.369374 23.1247 0 22.6691 0V0Z"
      fill="#212021"
    />
    <path
      d="M30.0077 5.7998C29.1562 5.7998 28.4658 6.49014 28.4658 7.34172C28.4658 8.1933 29.1562 8.88351 30.0077 8.88351C30.8593 8.88351 31.5495 8.19318 31.5495 7.34172C31.5495 6.49014 30.8592 5.7998 30.0077 5.7998Z"
      fill="#D15241"
    />
    <path
      d="M30.0075 0C29.552 0 29.1826 0.369374 29.1826 0.824896V7.2519C29.1826 7.70755 29.552 8.07679 30.0075 8.07679C30.463 8.07679 30.8324 7.70755 30.8324 7.2519V0.824896C30.8324 0.369374 30.4632 0 30.0075 0V0Z"
      fill="#212021"
    />
    <path d="M14.2192 18.8306H17.554V22.1653H14.2192V18.8306Z" fill="#212021" />
    <path
      d="M20.4458 18.8306H23.7806V22.1653H20.4458V18.8306Z"
      fill="#212021"
    />
    <path
      d="M26.6729 18.8306H30.0076V22.1653H26.6729V18.8306Z"
      fill="#212021"
    />
    <path
      d="M7.99268 24.0581H11.3275V27.3929H7.99268V24.0581Z"
      fill="#212021"
    />
    <path d="M14.2192 24.0581H17.554V27.3929H14.2192V24.0581Z" fill="#212021" />
    <path
      d="M20.4458 24.0581H23.7806V27.3929H20.4458V24.0581Z"
      fill="#E10500"
    />
    <path
      d="M26.6729 24.0581H30.0076V27.3929H26.6729V24.0581Z"
      fill="#212021"
    />
    <path
      d="M7.99268 29.2861H11.3275V32.6209H7.99268V29.2861Z"
      fill="#212021"
    />
    <path d="M14.2192 29.2861H17.554V32.6209H14.2192V29.2861Z" fill="#E10500" />
    <path
      d="M20.4458 29.2861H23.7806V32.6209H20.4458V29.2861Z"
      fill="#212021"
    />
  </SVGIcon>
);

export const iconCorrection = props => (
  <SVGIcon {...SIZE_ATTRIBUTES} {...props}>
    <g clipPath="url(#clip0)">
      <path
        d="M29.3711 5.25419H34.0396L29.3711 0.585938V5.25419Z"
        fill="#212021"
      />
      <path
        d="M28.2445 7.50655C27.6226 7.50655 27.1185 7.00238 27.1185 6.38022V-0.0742188H8.31354C7.69167 -0.0742188 7.1875 0.429948 7.1875 1.05211V21.1257C8.35993 20.636 9.64571 20.365 10.9938 20.365C11.6598 20.365 12.3103 20.4314 12.9398 20.5572C12.8644 20.4061 12.8209 20.2365 12.8209 20.0562C12.8209 19.4343 13.3253 18.9302 13.9472 18.9302H27.5125C28.1343 18.9302 28.6388 19.4343 28.6388 20.0562C28.6388 20.6784 28.1343 21.1825 27.5125 21.1825H14.9329C18.4412 22.709 20.9006 26.2083 20.9006 30.2717C20.9006 31.8492 20.5295 33.3411 19.8708 34.6663H33.5891C34.2113 34.6663 34.7155 34.1619 34.7155 33.54V7.50655H28.2445ZM23.4577 11.196C23.4577 11.8182 22.9535 12.3224 22.3313 12.3224H13.9472C13.3253 12.3224 12.8209 11.8182 12.8209 11.196C12.8209 10.5742 13.3253 10.0697 13.9472 10.0697H22.3313C22.9535 10.0697 23.4577 10.5739 23.4577 11.196ZM27.5125 16.7526H13.9472C13.3253 16.7526 12.8209 16.2481 12.8209 15.6263C12.8209 15.0041 13.3253 14.4999 13.9472 14.4999H27.5125C28.1343 14.4999 28.6388 15.0041 28.6388 15.6263C28.6388 16.2481 28.1343 16.7526 27.5125 16.7526Z"
        fill="#A6A9AD"
      />
      <path
        d="M18.6484 30.2718C18.6484 26.0512 15.2146 22.6177 10.994 22.6177C6.77363 22.6177 3.33984 26.0512 3.33984 30.2718C3.33984 34.4921 6.77334 37.9259 10.994 37.9259C15.2146 37.9259 18.6484 34.4921 18.6484 30.2718ZM10.3834 33.3281C10.1749 33.498 9.92329 33.5809 9.6728 33.5809C9.35737 33.5809 9.04368 33.4487 8.82132 33.1924L6.4985 30.5136C6.09087 30.0436 6.14161 29.3325 6.61156 28.9248C7.08152 28.5175 7.79269 28.5679 8.20031 29.0379L9.8079 30.8919L13.636 27.7753C14.1184 27.3828 14.8278 27.4552 15.2204 27.9377C15.6132 28.4201 15.5404 29.1295 15.058 29.5223L10.3834 33.3281Z"
        fill="#E10400"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="38" height="38" fill="white" />
      </clipPath>
    </defs>
  </SVGIcon>
);

export const iconPhoto = props => (
  <SVGIcon {...SIZE_ATTRIBUTES} {...props}>
    <g clipPath="url(#clip0)">
      <path
        d="M37.9998 13.8242V30.6075C37.9998 32.5235 36.4322 34.0908 34.5164 34.0908H9.81636C7.96408 34.0908 6.44405 32.6343 6.34895 30.8133C6.33301 30.7501 6.33301 30.671 6.33301 30.6075V13.8242C6.33301 11.9084 7.90059 10.3408 9.81636 10.3408H34.5164C36.4322 10.3408 37.9998 11.9084 37.9998 13.8242Z"
        fill="#B0BEC5"
      />
      <path
        d="M31.6668 7.49117V24.2745C31.6668 26.1902 30.0992 27.7578 28.1834 27.7578H3.48335C3.35666 27.7578 3.22997 27.7578 3.08762 27.7419C1.42494 27.552 0.110748 26.1746 0.0159455 24.4803C0 24.4171 0 24.338 0 24.2745V7.49117C0 5.57539 1.56758 4.00781 3.48335 4.00781H28.1834C30.0992 4.00781 31.6668 5.57539 31.6668 7.49117Z"
        fill="#ECEFF1"
      />
      <path
        d="M11.0832 10.3413C11.0832 12.0903 9.66554 13.508 7.91676 13.508C6.16769 13.508 4.75 12.0903 4.75 10.3413C4.75 8.5925 6.16769 7.1748 7.91676 7.1748C9.66554 7.1748 11.0832 8.5925 11.0832 10.3413Z"
        fill="white"
      />
      <path
        d="M31.6666 19.7464V24.2746C31.6666 26.1903 30.099 27.7579 28.1832 27.7579H3.48314C3.35645 27.7579 3.22975 27.7579 3.0874 27.742L19.4115 11.4179C20.4882 10.3412 22.2614 10.3412 23.3381 11.4179L31.6666 19.7464Z"
        fill="#E10500"
      />
      <path
        d="M22.2617 27.7577H3.48352C3.35683 27.7577 3.23013 27.7577 3.08778 27.7417C1.42511 27.5518 0.110916 26.1744 0.0161133 24.4802L7.53685 16.9594C8.6136 15.8827 10.3867 15.8827 11.4635 16.9594L22.2617 27.7577Z"
        fill="#212021"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="38" height="38" fill="white" />
      </clipPath>
    </defs>
  </SVGIcon>
);

export const iconRoster = props => (
  <SVGIcon {...SIZE_ATTRIBUTES} {...props}>
    <path
      d="M19.0001 18.6472C22.5914 18.6472 25.5031 15.1109 25.5031 10.7487C25.5031 6.38644 24.547 2.8501 19.0001 2.8501C13.453 2.8501 12.4971 6.38644 12.4971 10.7487C12.4972 15.1109 15.4087 18.6472 19.0001 18.6472Z"
      fill="#D2DCDF"
    />
    <path
      d="M31.2687 30.3882C31.1484 22.789 30.1559 20.6237 22.5613 19.2529C22.5613 19.2529 21.492 20.6151 19.0003 20.6151C16.5085 20.6151 15.4395 19.2529 15.4395 19.2529C7.92768 20.6086 6.87468 22.7419 6.73627 30.1412C6.72502 30.7454 6.71983 30.7771 6.71777 30.707C6.71816 30.8384 6.71875 31.0815 6.71875 31.5054C6.71875 31.5054 8.52691 35.1504 19.0004 35.1504C29.4738 35.1504 31.2822 31.5054 31.2822 31.5054C31.2822 31.2331 31.2824 31.0436 31.2826 30.9149C31.2805 30.9582 31.2763 30.8741 31.2687 30.3882Z"
      fill="#E10400"
    />
    <path
      d="M28.0245 17.2369C30.9414 17.2369 33.306 14.3647 33.306 10.8219C33.306 7.27886 32.5296 4.40674 28.0245 4.40674C27.2667 4.40674 26.6146 4.48827 26.0536 4.64048C27.0942 6.55875 27.2368 8.8887 27.2368 10.7485C27.2368 12.8543 26.666 14.8648 25.6147 16.5295C26.3373 16.9807 27.1561 17.2369 28.0245 17.2369Z"
      fill="#A6A9AD"
    />
    <path
      d="M37.9887 26.7723C37.8908 20.6004 37.0848 18.8418 30.9166 17.7285C30.9166 17.7285 30.0483 18.835 28.0245 18.835C27.9408 18.835 27.8597 18.8324 27.7798 18.8288C29.0656 19.4085 30.2354 20.2158 31.0969 21.397C32.5861 23.4391 32.9285 26.1823 32.9992 30.2123C37.149 29.3923 37.9995 27.6799 37.9995 27.6799C37.9995 27.4567 37.9995 27.3036 37.9999 27.199C37.9983 27.2358 37.9948 27.1698 37.9887 26.7723Z"
      fill="#212021"
    />
    <path
      d="M9.97521 17.2368C10.8437 17.2368 11.6623 16.9806 12.3851 16.5295C11.3339 14.8648 10.7631 12.8543 10.7631 10.7485C10.7631 8.88861 10.9057 6.55865 11.946 4.64048C11.3852 4.48827 10.7332 4.40674 9.97521 4.40674C5.47004 4.40674 4.69385 7.27886 4.69385 10.8219C4.69385 14.3646 7.05845 17.2368 9.97521 17.2368Z"
      fill="#A6A9AD"
    />
    <path
      d="M10.2199 18.8293C10.1403 18.8329 10.0591 18.8354 9.97524 18.8354C7.95145 18.8354 7.08315 17.729 7.08315 17.729C0.915088 18.8423 0.108941 20.6008 0.0112563 26.7728C0.00489404 27.1704 0.00166397 27.2363 0 27.1994C0.000195762 27.304 0.000391524 27.4571 0.000391524 27.6803C0.000391524 27.6803 0.850976 29.3927 5.00054 30.2127C5.0715 26.1828 5.41369 23.4396 6.90315 21.3974C7.7645 20.2164 8.93408 19.409 10.2199 18.8293Z"
      fill="#212021"
    />
  </SVGIcon>
);

export const iconVideo = props => (
  <SVGIcon {...SIZE_ATTRIBUTES} {...props}>
    <path
      d="M1.1875 8.90552V35.0328C1.1875 36.0094 1.99105 36.8118 2.96759 36.8118H35.0336C36.0101 36.8118 36.8125 36.0094 36.8125 35.0328V8.90552H1.1875Z"
      fill="#DBE9EE"
    />
    <path
      d="M2.96759 1.18677C1.99105 1.18677 1.1875 1.99027 1.1875 2.96681V9.49926H36.8125V2.96681C36.8125 1.99027 36.0101 1.18677 35.0336 1.18677H2.96759Z"
      fill="#212021"
    />
    <path
      d="M5.34297 3.56274C4.36625 3.56274 3.56348 4.3655 3.56348 5.34224C3.56348 6.31896 4.36625 7.12612 5.34297 7.12612C6.31969 7.12612 7.12685 6.31896 7.12685 5.34224C7.12685 4.3655 6.31969 3.56274 5.34297 3.56274Z"
      fill="#E10500"
    />
    <path
      d="M10.0944 3.56274C9.11772 3.56274 8.31494 4.3655 8.31494 5.34224C8.31494 6.31896 9.11772 7.12612 10.0944 7.12612C11.0712 7.12612 11.8739 6.31896 11.8739 5.34224C11.8739 4.3655 11.0712 3.56274 10.0944 3.56274Z"
      fill="#E10500"
    />
    <path
      d="M14.8454 3.56274C13.8687 3.56274 13.0615 4.3655 13.0615 5.34224C13.0615 6.31896 13.8687 7.12612 14.8454 7.12612C15.8221 7.12612 16.6249 6.31896 16.6249 5.34224C16.6249 4.3655 15.8221 3.56274 14.8454 3.56274Z"
      fill="#E10500"
    />
    <path
      d="M21.376 4.15445V6.53003C21.3747 6.85805 21.6397 7.12495 21.9677 7.12612H33.8456C34.1736 7.12493 34.4386 6.85805 34.4373 6.53003V4.15445C34.4362 3.82813 34.1719 3.56389 33.8456 3.56274H21.9392C21.6068 3.59304 21.3755 3.84905 21.376 4.15445Z"
      fill="#DBE9EE"
    />
    <path
      d="M5.34462 11.8745C5.26663 11.8742 5.18934 11.8893 5.11716 11.9189C5.04499 11.9485 4.97935 11.9919 4.924 12.0469C4.86865 12.1018 4.82466 12.1672 4.79455 12.2391C4.76445 12.3111 4.74881 12.3883 4.74854 12.4663V27.9075C4.74881 27.9855 4.76445 28.0627 4.79455 28.1347C4.82466 28.2066 4.86865 28.272 4.924 28.3269C4.97935 28.3819 5.04499 28.4254 5.11716 28.4549C5.18934 28.4845 5.26663 28.4996 5.34462 28.4993H32.6551C32.7331 28.4996 32.8104 28.4845 32.8825 28.4549C32.9547 28.4254 33.0204 28.3819 33.0757 28.3269C33.1311 28.272 33.175 28.2066 33.2052 28.1347C33.2353 28.0627 33.2509 27.9855 33.2512 27.9075V12.4663C33.2509 12.3883 33.2353 12.3111 33.2052 12.2391C33.175 12.1672 33.1311 12.1018 33.0757 12.0469C33.0204 11.9919 32.9547 11.9485 32.8825 11.9189C32.8104 11.8893 32.7331 11.8742 32.6551 11.8745H5.34462Z"
      fill="#A6A9AD"
    />
    <path
      d="M32.6547 32.0629C33.4465 32.0629 33.4465 30.875 32.6547 30.875H5.31355C4.4907 30.875 4.5531 32.1044 5.34423 32.0629H32.6547Z"
      fill="#212021"
    />
    <path
      d="M11.2705 29.6783C11.1137 29.6812 10.9645 29.7459 10.8552 29.8584C10.746 29.9709 10.6858 30.122 10.6875 30.2788V32.6544C10.6875 32.7324 10.7029 32.8096 10.7327 32.8817C10.7625 32.9538 10.8063 33.0192 10.8614 33.0744C10.9166 33.1296 10.9821 33.1734 11.0541 33.2032C11.1262 33.2331 11.2034 33.2484 11.2814 33.2484C11.3594 33.2484 11.4367 33.2331 11.5087 33.2032C11.5808 33.1734 11.6463 33.1296 11.7014 33.0744C11.7566 33.0192 11.8003 32.9538 11.8302 32.8817C11.86 32.8096 11.8754 32.7324 11.8753 32.6544V30.2788C11.8762 30.1993 11.8612 30.1205 11.831 30.0469C11.8009 29.9734 11.7563 29.9066 11.6999 29.8506C11.6435 29.7946 11.5764 29.7505 11.5027 29.7209C11.4289 29.6913 11.3499 29.6768 11.2705 29.6783Z"
      fill="#212021"
    />
    <path
      d="M16.0303 17.2173V23.1563C16.0305 23.6219 16.5421 23.9062 16.9376 23.6604L21.6887 20.6887C22.0573 20.4556 22.0573 19.918 21.6887 19.6849L16.9376 16.7132C16.5569 16.4752 16.0303 16.812 16.0303 17.2173Z"
      fill="#DBE9EE"
    />
  </SVGIcon>
);
